/* assets/card-swatches.js — robust swap using pointer events */
(function () {
  if (window.__lbCardSwatchesV4) return;
  window.__lbCardSwatchesV4 = true;

  function card(el) {
    return el.closest('.card-wrapper');
  }

  function imgsInCard(scope) {
    const c = card(scope);
    if (!c) return [];
    // grab every <img> inside the media block (primary + optional secondary)
    const imgs = c.querySelectorAll('.card__media .media img');
    if (imgs.length) return Array.from(imgs);
    // fallbacks if theme markup differs
    return Array.from(c.querySelectorAll('.card__media img, .media img'));
  }

  function remember(img) {
    if (!img || img.dataset.lbOrigSrc) return;
    img.dataset.lbOrigSrc = img.currentSrc || img.src;
    img.dataset.lbOrigSrcset = img.srcset || '';
    img.dataset.lbOrigSizes = img.sizes || '';
  }

  function swapTo(img, src, srcset) {
    if (!img || !src) return;
    remember(img);
    // Clear responsive candidates so the browser MUST use our src
    img.srcset = '';
    img.sizes = '';
    img.src = src;
    if (srcset) {
      // re-apply srcset AFTER src, some browsers only redraw if src changes first
      img.srcset = srcset;
      // make sure our srcset wins
      img.sizes = '100vw';
    }
  }

  function restore(img) {
    if (!img || !img.dataset.lbOrigSrc) return;
    img.srcset = '';
    img.sizes = '';
    img.src = img.dataset.lbOrigSrc;
    if (img.dataset.lbOrigSrcset) {
      img.srcset = img.dataset.lbOrigSrcset;
      img.sizes = img.dataset.lbOrigSizes || '100vw';
    }
  }

  function onSwatchEnter(e) {
    const swatch = e.currentTarget;
    const src = swatch.dataset.imageSrc;
    const srcset = swatch.dataset.imageSrcset;

    const imgs = imgsInCard(swatch);
    imgs.forEach(img => swapTo(img, src, srcset));

    const box = swatch.closest('.lb-card-swatches');
    const label = box && box.querySelector('[data-card-selected-color]');
    if (label && swatch.dataset.color) label.textContent = swatch.dataset.color;

    box.querySelectorAll('.lb-card-swatch.is-active').forEach(el => el.classList.remove('is-active'));
    swatch.classList.add('is-active');
  }

  function onBoxLeave(e) {
    const box = e.currentTarget;
    const to = e.relatedTarget;
    // If moving within the box, don't restore
    if (to && box.contains(to)) return;

    imgsInCard(box).forEach(restore);

    const initial =
      box.querySelector('.lb-card-swatch.is-initial') ||
      box.querySelector('.lb-card-swatch');

    box.querySelectorAll('.lb-card-swatch.is-active').forEach(el => el.classList.remove('is-active'));
    if (initial) {
      initial.classList.add('is-active');
      const label = box.querySelector('[data-card-selected-color]');
      if (label && initial.dataset.color) label.textContent = initial.dataset.color;
    }
  }

  function bind(box) {
    if (!box || box.__lbBound) return;
    box.__lbBound = true;
    box.setAttribute('data-js-bound', '1');

    // container leave
    box.addEventListener('pointerleave', onBoxLeave);
    box.addEventListener('focusout', onBoxLeave);

    // each swatch enter
    box.querySelectorAll('.lb-card-swatch').forEach(swatch => {
      swatch.addEventListener('pointerenter', onSwatchEnter);
      swatch.addEventListener('focusin', onSwatchEnter);
    });
  }

  function init() {
    document.querySelectorAll('.lb-card-swatches').forEach(bind);
  }

  // run immediately and on dynamic changes
  init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
  document.addEventListener('shopify:section:reorder', init);

  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      m.addedNodes && m.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (node.matches && node.matches('.lb-card-swatches')) bind(node);
        node.querySelectorAll && node.querySelectorAll('.lb-card-swatches').forEach(bind);
      });
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
